module.exports = __webpack_public_path__ + "img/carica.91d21936.png";